import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './Router';
import GlobalStyle from './_settings/GlobalStyle';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import theme from './theme';
import locale from 'antd/locale/pt_BR';
import dayjs from 'dayjs';
import { env } from './_settings/env';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { datadogRum } from '@datadog/browser-rum';

import 'dayjs/locale/pt-br';

datadogRum.init({
  applicationId: env.REACT_APP_DATADOG_APP_ID,
  clientToken: env.REACT_APP_DATADOG_CLIENT_TOKEN,
  defaultPrivacyLevel: 'allow',
  env: env.NODE_ENV,
  service: '4beefolha---frontend-admissão-digital',
  sessionReplaySampleRate: 100,
  sessionSampleRate: 100,
  site: 'datadoghq.com',
  version: '1.0.0',
});

dayjs.locale('pt-br');


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <ConfigProvider theme={theme} locale={locale}>
      <GoogleReCaptchaProvider reCaptchaKey={env.REACT_APP_RECAPTCHA_SITE_KEY || ''}>
        <Router />
      </GoogleReCaptchaProvider>
    </ConfigProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
